import { pxToRem } from 'utils/convert';

export const SEARCH_TEXT_INPUT_DEBOUNCE_TIMEOUT_MS = 500;

/**
  These represent back-end GraphQL enums for sorting
 */
export const SORT_BY_FIELD = {
  NAME: 'Name',
  METHOD: 'Method',
  ENDPOINT: 'Endpoint',
};

export const WORKFLOW_WEBHOOK_INDEX_COLUMNS = [
  { id: SORT_BY_FIELD.NAME, label: 'Name' },
  { id: SORT_BY_FIELD.METHOD, label: 'Method' },
  { id: SORT_BY_FIELD.ENDPOINT, label: 'Endpoint' },
];

export const WORKFLOW_WEBHOOK_GRIDS = `
  ${pxToRem(42)}
  2fr
  ${pxToRem(100)}
  1.75fr
  ${pxToRem(40)}
`;

export const SORT_DIRECTIONS = {
  ASCENDING: 'Ascending',
  DESCENDING: 'Descending',
};
